module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ed-Fb-Gc.adef3e7f.png";